<template>
  <div class="container">
    <div class="card">
      <div class="card-body">Something went wrong. iQuote is not correct. Please try again some other time.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageErrorIquoteNotCorrect',
}
</script>
